import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { LutienAuthPostLoginResponseDTO } from './dto/lutien-auth.postLogin.response.dto';
import { LutienAuthPostLoginBodyDTO } from './dto/lutien-auth.postLogin.body.dto';
import { LutienAuthGetMeResponseDTO } from './dto/lutien-auth.getMe.response.dto';
import { getAuthToken } from '@src/services/auth-service';

export class LutienAuthService {
  private readonly client: ApiInstance;
  private readonly hostedUi: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/auth`, client.getTimeout());
    this.hostedUi = new ApiInstance(`${client.getBaseUrl()}`, client.getTimeout());
  }

  async postLogin(request: {
    body: LutienAuthPostLoginBodyDTO;
    settings?: RetrySettings;
  }): Promise<LutienAuthPostLoginResponseDTO> {
    return (
      await this.client.post<LutienAuthPostLoginBodyDTO, LutienAuthPostLoginResponseDTO>(`login`, request.body, {
        settings: request.settings,
      })
    ).data;
  }

  async getMe(request: { bearerToken?: string; settings?: RetrySettings }): Promise<LutienAuthGetMeResponseDTO> {
    return (
      await this.client.get<LutienAuthGetMeResponseDTO>(
        `me`,
        {},
        {
          bearerToken: request.bearerToken ?? (await getAuthToken()),
          settings: request.settings,
        },
      )
    ).data;
  }

  async getHostedUiUrl(request: { domain?: string; workspace?: string }): Promise<{ hostedUi: string }> {
    const isLocalhost =
      window.location.hostname.includes('localhost') || window.location.hostname.includes('local.dev');
    const params = request.workspace
      ? { isLocalhost, workspace: request.workspace }
      : { isLocalhost, domain: request.domain };
    return (
      await this.hostedUi.get<{ hostedUi: string }>(`auth-providers/hosted-ui`, params, {
        settings: { maxRetries: 0, retryDelay: 0, delayType: 'linear' },
      })
    ).data;
  }
}
